import {
	ApartmentOutlined,
	BankOutlined,
	CalendarOutlined,
	ClockCircleOutlined,
	EnvironmentOutlined,
	GiftOutlined,
	HeartOutlined,
	HomeOutlined,
	IdcardOutlined,
	LockOutlined,
	MailOutlined,
	MedicineBoxFilled,
	PhoneOutlined,
	PoundOutlined,
	SolutionOutlined,
	TeamOutlined,
	ThunderboltOutlined,
	UploadOutlined,
	UserOutlined
} from "@ant-design/icons";
import { Alert, Avatar, Button, Col, Modal, Row, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import {
	clearUser,
	getLeavePolicyAndAllocation,
	loadSingleStaff
} from "../../redux/rtk/features/user/userSlice";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

import EmployeeDesignation from "../UI/EmployeeDesignation";
import EmployeeTimeline from "../UI/EmployeeTimeline";
import DesignationEditPopup from "../UI/PopUp/DesignationEditPopup";
import EducaitonEditPopup from "../UI/PopUp/EducaitonEditPopup";
import ProfileEditPopup from "../UI/PopUp/ProfileEditPopup";


import axios from "axios";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import { getDocumentsByUserId, updatedocumentForm } from "../../redux/rtk/features/document/documentSlice";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import GetToken from "../../utils/getToken";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import EmployeeAward from "../UI/EmployeeAward";
import EmployeeSalary from "../UI/EmployeeSalary";
import EmployeeWorkPlace from "../UI/EmployeeWorkPlace";
import AddressEditPopup from "../UI/PopUp/addressEditPopup";
import AwardHistoryEditPopup from "../UI/PopUp/AwardHistoryEditPopup";
import BankDetailPopup from "../UI/PopUp/bankDetailPopup";
import ContactEditPopup from "../UI/PopUp/contactEditPopup";
import EmployeeEditPopup from "../UI/PopUp/employeeEdit";
import LeaveEditPopup from "../UI/PopUp/leaveAllocationEdit";
import SalaryEditPopup from "../UI/PopUp/SalaryEditPopup";
import SensitiveDetailPopup from "../UI/PopUp/sensitiveDetailEditPopup";
import WorkPlaceEditPopup from "../UI/PopUp/workPlaceEditPopup";
dayjs.extend(weekday);
dayjs.extend(localeData);


//PopUp

const DetailStaff = () => {
	const { id } = useParams();
	const companyId = getCompanyIdFromToken();
	let navigate = useNavigate();
	const fileInputRef = useRef(null);
	//dispatch
	const dispatch = useDispatch();
	const user = useSelector((state) => state.users.user);
	const leaveData = useSelector((state) => state.users.leaveData);
	console.log("leaveData", leaveData);

	const error = useSelector((state) => state.users.error);
	const designation = useSelector((state) => state.designations.list);
	const { Option } = Select;
	const loginId = getUserFromToken();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const documentById = useSelector((state) => state.document.document);
	console.log("documentById", documentById);
	const imageUrl = documentById?.data?.[0]?.documentProofUrl;
	const [profileImage, setProfileImage] = useState(null);

	useEffect(() => {
		if (imageUrl) {
		  fetchUserImage(imageUrl);
		} else {
		  setProfileImage(null); // Reset profile image when no imageUrl exists
		}
	  }, [imageUrl]);

	const fetchUserImage = async (url) => {
		try {
			const token = GetToken();
			const response = await axios.get(url, {
				headers: {
					Authorization: `Bearer ${token}`
				},
				responseType: "blob",
			});

			const imageBlob = new Blob([response.data]);
			const imageObjectURL = URL.createObjectURL(imageBlob);
			setProfileImage(imageObjectURL);
		} catch (error) {
			console.error("Failed to load user image:", error);
			setProfileImage(null);
		}
	};


	const handleFileChange = async (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("id", id);
		formData.append("company_id", companyId);
		formData.append("documentType", "Profile");
		formData.append("documentOf", "user");
		formData.append("userId", id);
		formData.append("documentProof", file);
		try {
			const response = await dispatch(updatedocumentForm({ values: formData })).unwrap();

			if (response?.data?.documentProofUrl) {
				fetchUserImage(response.data.documentProofUrl);
			}
		} catch (error) {
			console.error("Error updating profile image:", error);
		}
	};


	console.log(designation, "designation");
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const onNavigateToDeletePage = () => {
		navigate('/admin/ProfileDelete');
	};
	const navigateToResetPassword = () => {
		navigate("/admin/resetPassword");
	};

	// Delete Supplier PopUp
	const [visible, setVisible] = useState(false);

	const handleVisibleChange = (newVisible) => {
		setVisible(newVisible);
	};

	useEffect(() => {
		dispatch(loadSingleStaff(id));
		return () => {
			dispatch(clearUser());
		};
	}, [id]);

	useEffect(() => {
		dispatch(getLeavePolicyAndAllocation({ companyId, id }));
		dispatch(loadAllDesignation());
		dispatch(getDocumentsByUserId(id))
	}, [dispatch]);



	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	const handleAvatarClick = () => {
		fileInputRef.current.click();
	};

	return (
		<div>
			<UserPrivateComponent permission={"readSingle-user"}>
				<PageTitle title=' Back  ' />

				{/* Action Buttons */}
				{/* <div className="flex justify-center py-4 px-2 mt-5 mr-2"> */}
				<div className="mr-8 ml-4 mb-0 mt-1" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					{loginId === user?.id && (
						<>
							<Button type="primary" onClick={() => setIsModalVisible(true)} >
								Manage Account
							</Button>
							<Modal
								title="Account Actions"
								visible={isModalVisible}
								onCancel={() => setIsModalVisible(false)}
								footer={null}
							>
								<Space direction="vertical" size="middle" style={{ width: "100%" }}>
									<Button
										type="default"
										icon={<LockOutlined />}
										onClick={navigateToResetPassword}
										block
									>
										Reset Password
									</Button>
									{/* <Button
									type="primary"
									danger
									icon={<UserDeleteOutlined />}
									onClick={onNavigateToDeletePage}
									block
								>
									Delete my profile
								</Button> */}
								</Space>
							</Modal>
						</>
					)}


					<div style={{ position: "relative", cursor: "pointer" }} onClick={handleAvatarClick}>
						<Avatar
							src={profileImage || undefined}
							icon={!profileImage && <UserOutlined />}
							size={100}
							style={{ border: "2px solid #ddd", backgroundColor: "#f5f5f5" }}
						/>
						<div style={{
							position: "absolute",
							bottom: 0,
							right: 0,
							background: "#e6f7ff",
							borderRadius: "50%",
							padding: "5px",
							cursor: "pointer",
						}}>
							<UploadOutlined style={{ color: "#000", fontSize: "20px" }} />
						</div>
						<input
							type="file"
							ref={fileInputRef}
							style={{ display: "none" }}
							accept="image/*"
							onChange={handleFileChange}
						/>
					</div>

				</div>
				{user ? (
					<div className=''>
						<section>
							<div className='flex justify-between ant-card rounded h-auto mr-8'>
								{/* Profile Card */}

								{/* <div className='flex justify-start'> */}
								{/*	<img
										src='https://cdn-icons-png.flaticon.com/512/2202/2202112.png'
										alt='profile'
										className='rounded-full h-40 w-40 m-5'
									/> */}
								{/* <div class='flex justify-center py-8 px-4 mt-4 ml-4'>
										<div class='flex flex-col items-around'>
											<h1 class='text-2xl font-bold txt-color-2 mb-1'>
												{(user?.firstName + " " + user?.lastName).toUpperCase()}
											</h1>
											<h2 class='text-base font-medium txt-color-secondary mb-1'>
												{user?.designationHistory[0]?.designation?.name ||
													"No Designation"}
											</h2>
											<h3 class='text-base font-medium txt-color-secondary'>
												{user?.department?.name || "No Department"}
											</h3>
											<h3 class='text-base font-medium txt-color-secondary'>
												{user?.employeeId || "No Employee ID"}
											</h3>

										</div>
									</div>
								</div> */}

								{/* Leave Status */}
								{/* <div className=''>
									<div className='flex justify-center py-8 px-4 mt-4'>
										<div className='flex flex-col items-around'>
											<h1 className='text-2xl font-bold txt-color-2 mb-1'>
												Leave Status
											</h1>

											<h3 className='text-base font-medium txt-color-secondary'>
												Leaves :{" "}
												<span className='text-base font-medium txt-color-2'>
													Paid - {user?.leavePolicy?.paidLeaveCount ?? 0} | U.Paid -{" "}
													{user?.leavePolicy?.unpaidLeaveCount ?? 0}
												</span>
											</h3>
											<h3 className='text-base font-medium txt-color-secondary'>
												Taken :{" "}
												<span className='text-base font-medium txt-color-2'>
													Paid -{" "}
													{(user?.leavePolicy?.paidLeaveCount ?? 0) -
														(user?.leftPaidLeaveDays ?? 0)}{" "}
													| U.Paid -{" "}
													{(user?.leavePolicy?.unpaidLeaveCount ?? 0) -
														user?.leftUnpaidLeaveDays ?? 0}
												</span>
											</h3>
											<h3 className='text-base font-medium txt-color-secondary'>
												Balance :{" "}
												<span className='text-base font-medium txt-color-2'>
													Paid - {user?.leftPaidLeaveDays} | U.Paid -{" "}
													{user?.leftUnpaidLeaveDays}
												</span>
											</h3>
										</div>
									</div>
								</div> */}


								{/*Clock In and Out Time*/}

								{/* <div className='flex justify-center py-8 px-4 mt-4'>
									<div className='flex flex-col items-around'>
										<h1 className='text-2xl font-bold txt-color-2 mb-1'>
											Clock In  Out
										</h1>

										<h3 className='text-base font-medium txt-color-secondary'>
											In Time :{" "}
											<span className='text-base font-medium txt-color-2'>
												{dayjs(user?.attendance.inTime).format("hh:mm A")}
											</span>
										</h3>

										<h3 className='text-base font-medium txt-color-secondary'>
											Out Time :{" "}
											<span className='text-base font-medium txt-color-2'>
												{dayjs(user?.attendance.outTime).format("hh:mm A")}
											</span>
										</h3>
									</div>
								</div> */}



								{/* Action Buttons */}

								{/* <div className=''>
									<div className='flex justify-center py-8 px-4 mt-10 mr-4'>
										<UserPrivateComponent permission='update-user'>
											<button className='mr-2 mt-2'>
												{user && <ProfileEditPopup data={user} />}
											</button>
										</UserPrivateComponent>

									</div>
								</div> */}
							</div>
						</section>
						<Row
							className='mt-5'
							gutter={{
								xs: 8,
								sm: 16,
								md: 24,
								lg: 32,
								xl: 32,
							}}>
							{user && (
								<Col
									xs={24}
									sm={12}
									md={12}
									lg={11}
									xl={11}
									className='new-card rounded h-auto m-2'>

									<div className='flex justify-between items-center'>
										<ProfileCardText className='text-start'>
											Personal Information
										</ProfileCardText>
										<UserPrivateComponent permission={"update-user"}>
											<ProfileEditPopup userId={user?.id} user={user} />
										</UserPrivateComponent>
									</div>

									<Hr />

									<div className='m-5'>
										<ul className='space-y-4'>
											<li className='flex items-center'>
												<UserOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>Full Name:</span>
												<p className='txt-color-secondary ml-2'>
													{/* {user?.firstName || "Not Available"} */}
													{/* {(user?.salutations?.salutations + " " +user?.firstName + " " + user?.lastName).toUpperCase() || "Not Available"} */}
													{((user?.salutations?.salutations ? user.salutations.salutations + " " : "") +
														(user?.firstName || "") + " " +
														(user?.lastName || "")).trim().toUpperCase() || "Not Available"}

												</p>
											</li>

											<li className='flex items-center'>
												<UserOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>User Name:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.userName || "Not Available"}
												</p>
											</li>


											{/* Gender */}
											<li className='flex items-center'>
												<UserOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>Gender:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.genders?.gender || "Not Available"}
												</p>
											</li>
											{/* Birth Anniversary */}
											<li className='flex items-center'>
												<GiftOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>D.O.B:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.birthAnniversary
														? dayjs(user?.birthAnniversary).format("DD/MM/YYYY")
														: "Not Available"}
												</p>
											</li>
											{/* Blood Group */}
											<li className='flex items-center'>
												<ThunderboltOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>Blood Group:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.bloodGroup || "Not Available"}
												</p>
											</li>



											{/* Birthday */}
											{/* <li className='flex items-center'>
												<CalendarOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>Birthday:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.birthdate
														? dayjs(user?.birthdate).format("DD/MM/YYYY")
														: "Not Available"}
												</p>
											</li> */}

											{/* Marital Status */}
											<li className='flex items-center'>
												<HeartOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>Marital Status:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.maritalStatus === null
														? "N/A"
														: user?.maritalStatus === 1
															? "Married"
															: "Single"}
												</p>
											</li>


											{/* Marriage Anniversary */}
											{/* <li className='flex items-center'>
												<CalendarOutlined className='mr-3' style={{ fontSize: "15px" }} />
												<span className='txt-color-2 font-medium'>Marriage Anniversary:</span>
												<p className='txt-color-secondary ml-2'>
													{user?.marriageAnniversary
														? dayjs(user?.marriageAnniversary).format("DD/MM/YYYY")
														: "Not Available"}
												</p>
											</li> */}




										</ul>
									</div>


								</Col>
							)}
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								className='new-card rounded h-auto m-2'>
								<div className='flex justify-between items-center'>
									<ProfileCardText className='text-start'>
										Contact Information
									</ProfileCardText>
									<UserPrivateComponent permission={"update-user"}>
										<ContactEditPopup userId={user?.id} user={user} />
									</UserPrivateComponent>
								</div>

								<Hr />
								<div className='m-5'>
									<ul className='space-y-4'>
										{/* Email */}
										<li className='flex items-center'>
											<MailOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Email:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.email || "Not Available"}
											</p>
										</li>
										{/* Phone Number */}
										<li className='flex items-center'>
											<PhoneOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Phone:</span>
											<p className='txt-color-secondary ml-2'>{user?.phone || "No Phone"}</p>
										</li>

										{/* Alternate Number */}
										<li className='flex items-center'>
											<PhoneOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Alternate Number:</span>
											<p className='txt-color-secondary ml-2'>{user?.alternateNumber || "No Alternate Number"}</p>
										</li>

										{/* Emergency Contact Number */}
										<li className='flex items-center'>
											<PhoneOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Emergency Contact:</span>
											<p className='txt-color-secondary ml-2'>{user?.emergencyContactNumber || "No Emergency Contact"}</p>
										</li>
										{/* Emergency Contact Number */}
										<li className='flex items-center'>
											<UserOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Emergency Contact Person:</span>
											<p className='txt-color-secondary ml-2'>{user?.contactPersonName || "No Emergency Contact"}</p>
										</li>


										{/* Contact Person Relation */}
										<li className='flex items-center'>
											<UserOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Contact Person Relation:</span>
											<p className='txt-color-secondary ml-2'>{user?.relationship?.relationship || "No Relation Provided"}</p>
										</li>
									</ul>
								</div>

							</Col>
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className='new-card rounded h-auto m-2'>

								<div className='flex justify-between items-center'>
									<ProfileCardText className='text-start'>
										Employee Information
									</ProfileCardText>
									<UserPrivateComponent permission={"update-role"}>
										<EmployeeEditPopup userId={user?.id} user={user} />
									</UserPrivateComponent>
								</div>
								<Hr />

								<div className='m-5'>
									<ul className='space-y-4'>
										<li className='flex items-center'>
											<IdcardOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Company Name:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.companyMaster?.company_name || "Not Available"}
											</p>
										</li>
										<li className='flex items-center'>
											<IdcardOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Employee ID:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.employeeId || "Not Available"}
											</p>
										</li>
										{/* <li className='flex items-center'>
											<IdcardOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Company Name:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.companyMaster?.company_name || "Not Available"}
											</p>
										</li> */}

										<li className='flex items-center'>
											<MailOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Official Mail:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.officialMailId || "Not Available"}
											</p>
										</li>

										<li className='flex items-center'>
											<CalendarOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Join Date:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.joinDate
													? dayjs(user?.joinDate).format("DD/MM/YYYY")
													: "Not Available"}
											</p>
										</li>

										<li className='flex items-center'>
											<CalendarOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Probation Period:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.probationPeriod
													? dayjs(user?.probationPeriod).format("DD/MM/YYYY")
													: "Not Available"}
											</p>
										</li>

										{/* <li className='flex items-center'>
											<SafetyOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>ESIC:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.esic || "Not Available"}
											</p>
										</li> */}

										<li className='flex items-center'>
											<TeamOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Employment Status:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.employmentStatus?.name || "No Employment Status"}
											</p>
										</li>

										<li className='flex items-center'>
											<ApartmentOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Department:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.department?.name || "No Department"}
											</p>
										</li>

										<li className='flex items-center'>
											<UserOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Reporting Manager:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.reportingManager
													? `${user.reportingManager.firstName} ${user.reportingManager.lastName}`
													: "Not Assigned"}
											</p>
										</li>


										<li className='flex items-center'>
											<UserOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Role:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.role?.name || "No Role"}
											</p>
										</li>

										<li className='flex items-center'>
											<ClockCircleOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Shift:</span>
											{/* <p className='txt-color-secondary ml-2'>
												{user?.shift?.name || "No Shift"} (
												{dayjs(user?.shift?.startTime).format("HH:MM")} -{" "}
												{dayjs(user?.shift?.endTime).format("HH:MM")})
											</p> */}
											<p className='txt-color-secondary ml-2'>
												{user?.shift?.name || "No Shift"} (
												{dayjs.utc(user?.shift?.startTime).format("HH:mm")} -
												{dayjs.utc(user?.shift?.endTime).format("HH:mm")})
											</p>

										</li>

										<li className='flex items-center'>
											<CalendarOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Weekly Off:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.weeklyHoliday?.name || "Not Available"}
											</p>
										</li>

										<li className='flex items-center'>
											<CalendarOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Notice Period:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.noticePeriod?.noticePeriod || "Not Available"}
											</p>
										</li>


										<li className='flex items-center'>
											<SolutionOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Pension:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.pfEligiblity ? "Eligible" : "Not Eligible"}
											</p>
										</li>

										{/* <li className='flex items-center'>
											<BarcodeOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>NI No:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.uan || "Not Available"}
											</p>
										</li> */}

										<li className='flex items-center'>
											<PoundOutlined
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Payment Type:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.tbl_paymentType?.[0]?.payment_type.paymentType || "Not Specified"}
											</p>
										</li>

										<li className='flex items-center'>
											<MedicineBoxFilled
												className='mr-3'
												style={{ fontSize: "15px" }}
											/>
											<span className='txt-color-2 font-medium'>Medical Info.:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.medicalInfo || "Not Available"}
											</p>
										</li>
									</ul>
								</div>
							</Col>


							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className='new-card rounded h-auto m-2'>
								{/* <ProfileCardText className='text-start'>Address Details</ProfileCardText> */}
								<div className='flex justify-between items-center'>
									<ProfileCardText className='text-start'>
										Address Details
									</ProfileCardText>
									<UserPrivateComponent permission={"update-user"}>
										<AddressEditPopup
											userId={user?.id}
											user={user}
										/>
									</UserPrivateComponent>
								</div>
								<Hr />

								<div className='m-5'>
									<ul className='space-y-4'>
										{/* Current Address Heading */}
										<li className='flex items-center'>
											<HomeOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-primary font-medium'>Current Address</span>
										</li>

										{/* Current Address Fields */}
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Address:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.street || "Not Available"}
											</p>
										</li>
										{/* <li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>City:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.city || "Not Available"}
											</p>
										</li> */}
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>City:</span>
											<p className='txt-color-secondary ml-2'>
												{/* {user?.States?.stateName || "Not Available"} */}
												{user?.city || "Not Available"}

											</p>
										</li>
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Post Code:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.zipCode || "Not Available"}
											</p>
										</li>
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Country:</span>
											<p className='txt-color-secondary ml-2'>
												{/* {user?.countries?.countryName || "Not Available"} */}
												{user?.country || "Not Available"}

											</p>
										</li>

										{/* Divider */}
										<li>
											<Hr />
										</li>

										{/* Permanent Address Heading */}
										<li className='flex items-center'>
											<HomeOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-primary font-medium'>Permanent Address</span>
										</li>

										{/* Permanent Address Fields */}
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Address:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.pAddress || "Not Available"}
											</p>
										</li>
										{/* <li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>City:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.pCity || "Not Available"}
											</p>
										</li> */}
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>City:</span>
											<p className='txt-color-secondary ml-2'>
												{/* {user?.permanentState?.stateName || "Not Available"} */}
												{user?.pCity || "Not Available"}

											</p>
										</li>
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Post Code:</span>
											<p className='txt-color-secondary ml-2'>
												{user?.pZipCode || "Not Available"}
											</p>
										</li>
										<li className='flex items-center'>
											<EnvironmentOutlined className='mr-3' style={{ fontSize: "15px" }} />
											<span className='txt-color-2 font-medium'>Country:</span>
											<p className='txt-color-secondary ml-2'>
												{/* {user?.permanentCountry?.countryName || "Not Available"} */}
												{user?.pCountry || "Not Available"}

											</p>
										</li>
									</ul>
								</div>
							</Col>

							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className="new-card rounded h-auto m-2"
							>
								<div className="flex justify-between">
									<ProfileCardText className="text-start">WorkPlace History</ProfileCardText>
									<UserPrivateComponent permission={"update-designationHistory"}>
										{user?.workPlaceHistory && (
											<WorkPlaceEditPopup data={user?.workPlaceHistory} />
										)}
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className="flex justify-start ml-10">
									{user?.workPlaceHistory?.length !== 0 ? (
										<EmployeeWorkPlace list={user?.workPlaceHistory} />
									) : (
										<div className="mb-10">
											<p className="text-center mt-3 mb-3">No WorkPlace History Found</p>
											<Alert
												message="Not found, click on edit button to add new"
												type="info"
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>


							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className='new-card rounded h-auto m-2'>
								<div className='flex justify-between'>
									<ProfileCardText className='text-start'>
										Designation History
									</ProfileCardText>

									<UserPrivateComponent
										permission={"update-designationHistory"}>
										{user?.designationHistory && (
											<DesignationEditPopup data={user?.designationHistory} />
										)}
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className='flex justify-start ml-10'>
									{user?.designationHistory?.length !== 0 ? (
										<EmployeeDesignation list={user?.designationHistory} />
									) : (
										<div className='mb-10'>
											<p className='text-center mt-3 mb-3'>
												No Designation History Found
											</p>
											<Alert
												message='Not found , Click on edit button to add new'
												type='info'
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={12}
								className='new-card rounded h-auto m-2 '>
								<div className='flex justify-between'>
									<ProfileCardText className='text-start'>
										Education History
									</ProfileCardText>
									<UserPrivateComponent permission={"update-education"}>
										{user?.educations && (
											<EducaitonEditPopup data={user?.educations} />
										)}
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className='flex justify-start ml-10'>
									{user?.educations?.length !== 0 ? (
										<EmployeeTimeline list={user?.educations} />
									) : (
										<div className='mb-10'>
											<p className='text-center mt-3 mb-3'>
												No Education History Found
											</p>
											<Alert
												message='Not found , Click on edit button to add new'
												type='info'
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>

							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className='new-card rounded h-auto m-2 '>
								<div className='flex justify-between'>
									<ProfileCardText className='text-start'>
										Salary History
									</ProfileCardText>
									<UserPrivateComponent permission={"update-salaryHistory"}>
										{user?.contract_details && (
											<SalaryEditPopup data={user?.contract_details} />
										)}
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className='flex justify-start ml-10'>
									{user?.contract_details?.length !== 0 ? (
										<EmployeeSalary list={user?.contract_details} />
									) : (
										<div className='mb-10'>
											<p className='text-center mt-3 mb-3 '>
												No Salary History Found
											</p>
											<Alert
												message='Not found , Click on edit button to add new'
												type='info'
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>

							{/* Bank Details Section */}
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className='new-card rounded h-auto m-2'
							>
								<div className='flex justify-between'>
									<ProfileCardText className='text-start'>
										Bank Details
									</ProfileCardText>

									<UserPrivateComponent permission='update-user'>
										<button className='mr-2 mt-2'>
											{/* Show BankDetailPopup regardless of whether bank details exist */}
											<BankDetailPopup
												data={user?.bankDetails?.[0] || {}}
											/>
										</button>
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className='m-5'>
									{user?.bankDetails && user.bankDetails?.length > 0 ? (
										<ul className='space-y-4'>
											<li className='flex items-center'>
												<BankOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Account Holder:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.bankDetails[0]?.accountHolderName || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<BankOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Bank Name:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.bankDetails[0]?.bankName || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<BankOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Account Number:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.bankDetails[0]?.accountNumber || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<BankOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Short Code:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.bankDetails[0]?.shortCode || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<BankOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Branch:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.bankDetails[0]?.branchName || 'N/A'}
												</p>
											</li>
										</ul>
									) : (
										<div className='mb-10'>
											<p className='text-center mt-3 mb-3'>
												No Bank Details Found
											</p>
											<Alert
												message='Not found, Click on edit button to add new'
												type='info'
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>

							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={11}
								className='new-card rounded h-auto m-2'
							>
								<div className='flex justify-between'>
									<ProfileCardText className='text-start'>
										Sensitive Details
									</ProfileCardText>

									<UserPrivateComponent permission='update-user'>
										<button className='mr-2 mt-2'>
											<SensitiveDetailPopup
												data={user?.sensitive_detail?.[0] || {}}
											/>
										</button>
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className='m-5'>
									{user?.sensitive_detail && user.sensitive_detail?.length > 0 ? (
										<ul className='space-y-4'>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													NI Number:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.NINumber || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Tax Code:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.taxCode || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Passport Number:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.passportNumber || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Country of Issue (Passport):
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.issue_country?.issueCountry || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Passport Expiry:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.passportExpiryDate
														? new Date(user.sensitive_detail[0].passportExpiryDate).toLocaleDateString()
														: 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													License Number:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.licenseNumber || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Country of Issue (License):
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.licenseCountry?.issueCountry || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													License Expiry:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.DLExpiryDate
														? new Date(user.sensitive_detail[0].DLExpiryDate).toLocaleDateString()
														: 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Visa Number:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.visaNumber || 'N/A'}
												</p>
											</li>
											<li className='flex items-center'>
												<IdcardOutlined
													className='mr-3'
													style={{ fontSize: "15px" }}
												/>
												<span className='txt-color-2 font-medium'>
													Visa Expiry:
												</span>
												<p className='txt-color-secondary ml-2'>
													{user.sensitive_detail[0]?.visaExpiryDate
														? new Date(user.sensitive_detail[0].visaExpiryDate).toLocaleDateString()
														: 'N/A'}
												</p>
											</li>
										</ul>
									) : (
										<div className='mb-10'>
											<p className='text-center mt-3 mb-3'>
												No Sensitive Details Found
											</p>
											<Alert
												message='Not found, Click on edit button to add new'
												type='info'
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>
							{/* Documents Section */}
							{/* <Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								className="new-card rounded h-auto m-2"
							> */}
							{/* <div className="flex justify-between">
									<ProfileCardText className="text-start">
										Update Document
									</ProfileCardText>
									<UserPrivateComponent permission={"update-user"}>
										<button onClick={showModal} aria-label="Edit Document Details">
											<BtnEditSvg size={30} />
										</button>
										<Modal
											title="Update Document Details"
											visible={isModalVisible}
											onCancel={handleCancel}
											footer={null}
											width={800}
										>
											<DocumentEditPopup />
										</Modal>
									</UserPrivateComponent>
								</div> */}
							{/* <Hr />
								<div className="m-5">
									{user?.documents && user.documents.length > 0 ? (
										<ul className="space-y-4">
											{user.documents.map((doc, index) => (
												<li key={doc.id} className="flex items-center">
													<FileOutlined className="mr-3" style={{ fontSize: "15px" }} />
													<p className="txt-color-secondary ml-2">
														{doc.documentType}
													</p>
													{doc.uploadFile && (
														<div className="ml-2">
															
															{doc.uploadFile.endsWith(".pdf") ? (
																<a
																	href={`http://93.127.198.13:2002/document-proof/${doc.uploadFile}`}
																	target="_blank"
																	rel="noopener noreferrer"
																	className="text-blue-500"
																>
																	View Document
																</a>
															) : (
																
																<img
																	src={`http://93.127.198.13:2002/document-proof/${doc.uploadFile}`}
																	alt={doc.documentType}
																	style={{ width: 100, height: 100, objectFit: "cover" }}
																/>
															)}
														</div>
													)}
												</li>
											))}
										</ul>
									) : (
										<div className="mb-10">
											<p className="text-center mt-3 mb-3">No Documents Found</p>
											<Alert
												message="Not found, Click on edit button to add new"
												type="info"
												showIcon
											/>
										</div>
									)}
								</div>
							</Col> */}
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								className="new-card rounded h-auto m-2"
							>
								<div className="flex justify-between items-center">
									<ProfileCardText className="text-start">Leave Information</ProfileCardText>
									<UserPrivateComponent permission={"update-awardHistory"}>
										<LeaveEditPopup leaveData={leaveData} id={id} />

									</UserPrivateComponent>
								</div>

								<Hr />
								<div className="m-5">
									<ul className="space-y-4">
										{leaveData?.data && leaveData.data.map((leave) => (
											<li key={leave.id} className="flex items-center">
												<span className="txt-color-2 font-medium">{leave.name}:</span>
												<div className="ml-2">
													<p className="txt-color-secondary">{leave.allocation.annualLeave}</p>
													{/* <p className="txt-color-secondary">Monthly Leave: {leave.allocation.monthlyLeave}</p> */}
												</div>
											</li>
										))}
									</ul>
								</div>
							</Col>


							<Col
								xs={24}
								sm={12}
								md={12}
								lg={11}
								xl={12}
								className='new-card rounded h-auto m-2 '>
								<div className='flex justify-between'>
									<ProfileCardText className='text-start'>
										Award History
									</ProfileCardText>

									<UserPrivateComponent permission={"update-awardHistory"}>
										{user?.awardHistory && (
											<AwardHistoryEditPopup data={user?.awardHistory} />
										)}
									</UserPrivateComponent>
								</div>
								<Hr />
								<div className='flex justify-start ml-10'>
									{user?.awardHistory?.length !== 0 ? (
										<EmployeeAward list={user?.awardHistory} />
									) : (
										<div className='mb-10'>
											<p className='text-center mt-3 mb-3 '>
												No Award History Found
											</p>
											<Alert
												message='Not found , Click on edit button to add new'
												type='info'
												showIcon
											/>
										</div>
									)}
								</div>
							</Col>
						</Row>
					</div>
				) : (
					<div className='mt-10'>
						<Loader />
						{error && <p className='text-center mt-3 mb-3'>No Data Found</p>}
					</div>
				)}
			</UserPrivateComponent>
		</div>
	);
};

const ProfileCardText = tw.div`
txt-color-2
text-xl
 text-center
  mt-5 `;

const Hr = tw.hr`
mt-3
mb-3
new-hr

`;

const Information = tw.div`
m-5
`;

export default DetailStaff;
